@let currentRow = row();
@let realisation = currentRow.realisation;
@let realisationForm = currentRow.form;
@let isMarkedForRemoval = !!realisationForm.controls.removed.value;
@let notEditableMessage = realisation | notEditable;
@let notApprovableMessage = realisation | notApprovable;
@let approveAllDisabled = !!(notApprovableMessage || notEditableMessage || realisationForm.disabled);

<div class="container-xl">
    <div
        class="content d-flex flex-wrap align-items-center column-gap-3 py-2"
        [class.removed]="isMarkedForRemoval"
        [class.approved]="!!realisation.approved"
        [class.not-approvable]="notApprovableMessage"
        [class.not-editable]="notEditableMessage"
        [class.pe-none]="selectionMode() || realisationForm.disabled"
        [class.pt-4]="currentRow.isFirstGroup"
        [class.pb-4]="currentRow.isLastGroup && !(hasMessages || (canApproveHours && currentRow.showApproveAll))"
        [class.pb-0]="hasMessages || (canApproveHours && currentRow.showApproveAll)">
        <app-realisation-row-name class="name-wrapper order-lg-2" [row]="currentRow" />
        <div class="prefix d-flex flex-shrink-0 flex-row-reverse flex-lg-row align-items-center order-lg-1">
            <app-realisation-row-prefix
                [notEditable]="!!notEditableMessage"
                [row]="currentRow"
                (pauseUpdated)="pauseUpdated.emit($event)" />
            <app-realisation-row-counts-total
                class="counts-total d-flex d-md-none align-items-center order-1 order-lg-4 ms-2 me-2 me-lg-0"
                [entityRegisteredMinutes]="currentRow.entityRegisteredMinutes"
                [userId]="realisation.user_id"
                [userRegisteredMinutes]="currentRow.userRegisteredMinutes" />
        </div>

        <app-realisation-row-time-project
            class="times order-md-3 mb-3"
            [class.pe-none]="disabled()"
            [driverRealisations]="currentRow.driverRealisations"
            [form]="realisationForm"
            [notEditable]="!!notEditableMessage"
            [projectId]="currentRow.projectId"
            [projectName]="currentRow.projectName"
            [realisation]="realisation"
            (projectEdit)="projectEdit.emit()"
            (timeEdit)="timeEdit.emit($event)" />

        <app-realisation-row-counts-total
            class="counts-total d-none d-md-flex align-items-center order-1 order-lg-4 ms-2 me-2 me-lg-0"
            [entityRegisteredMinutes]="currentRow.entityRegisteredMinutes"
            [userId]="realisation.user_id"
            [userRegisteredMinutes]="currentRow.userRegisteredMinutes" />

        <app-realisation-row-buttons
            class="buttons d-flex flex-row-reverse flex-md-row align-items-center justify-content-between order-md-3 order-lg-4"
            [class.pe-none]="disabled()"
            [form]="realisationForm"
            [notApprovable]="!!notApprovableMessage"
            [notEditable]="!!notEditableMessage"
            [realisation]="realisation"
            (approveRequested)="approveRequested.emit()"
            (removeRequested)="removeRequested.emit()"
            (restoreRequested)="restoreRequested.emit()" />

        @if (canApproveHours && currentRow.showApproveAll) {
            <div class="approve-all d-none d-xxl-block position-absolute order-last mt-3 mt-md-0">
                <button
                    class="toggle d-flex align-items-center justify-content-center bg-transparent fs-5 curpoint"
                    [class.pe-none]="approveAllDisabled"
                    [disabled]="approveAllDisabled"
                    (click)="approveAllInGroup($event)"
                    type="button"
                    aria-label="Transport- en reisuren goedkeuren"
                    matTooltip="Transport- en reisuren goedkeuren">
                    <i class="fas fa-check"></i>
                </button>
            </div>
        }
    </div>

    @if (hasMessages || (canApproveHours && currentRow.showApproveAll)) {
        <div
            class="content d-flex flex-wrap align-items-center justify-content-end column-gap-3 pt-0 py-2"
            [class.pe-none]="selectionMode()"
            [class.pb-4]="currentRow.isLastGroup">
            @if (hasMessages) {
                <div class="comment">
                    @if (realisation.comment_user) {
                        <div class="mt-2">
                            <b>Toelichting: </b>
                            <span [innerHTML]="realisation.comment_user | nl2br"></span>
                        </div>
                    }

                    @if (realisation.comment_manager) {
                        <div>
                            <b>Toelichting uitvoerder: </b>
                            <span [innerHTML]="realisation.comment_manager | nl2br"></span>
                        </div>
                    }

                    @if (realisation.comment_user_approved) {
                        <div>
                            <b>Opmerking na goedkeuring: </b>
                            <span [innerHTML]="realisation.comment_user_approved | nl2br"></span>

                            @if (realisation.comment_user_approved_handled) {
                                <br />
                                Verwerkt:
                                {{ realisation.comment_user_approved_handled | date: 'd MMMM yyyy HH:mm' }}
                            }
                        </div>
                    }
                </div>
            }

            @if (canApproveHours && currentRow.showApproveAll) {
                <div class="approve-all mobile d-xxl-none mt-3 mt-md-0">
                    <button
                        class="toggle d-flex align-items-center justify-content-center bg-transparent fs-5 curpoint"
                        [class.pe-none]="approveAllDisabled"
                        [disabled]="approveAllDisabled"
                        (click)="approveAllInGroup($event)"
                        type="button"
                        aria-label="Transport- en reisuren goedkeuren"
                        matTooltip="Transport- en reisuren goedkeuren">
                        <i class="fas fa-check"></i>
                    </button>
                </div>
            }
        </div>
    }
</div>
